
const layersConfig = [
  {
    "type": "WMS",
    "text": "Ortho Photos - 2021",
    "name": "2018_Orthophotos",
    "url": "/wms/JohnstonCo?",
    "params": {
      "layers": "orthos_2021"
    }
  },{
    "type": "WMS",
    "text": "Soils - colors",
    "name": "Soils",
    "url": "/wms/JohnstonCo?",
    "params": {
      "layers": "soil"
    }
  },{
    "type": "WMS",
    "text": "Soils - contours",
    "name": "Soils_contours",
    "url": "/wms/JohnstonCo?",
    "params": {
      "layers": "soil_contours"
    }
  },{
    "type": "WMS",
    "text": "County Boundaries",
    "name": "official_county_boundaries",
    "visible": true,
    "url": "/wms/JohnstonCo?",
    "params": {
      "layers": "official_county_boundaries",
      "transparent": true
    },
    "options": {
    }
  },{
    "type": "WMS",
    "text": "City Limits",
    "name": "JC-City_Limits",
    "visible": true,
    "url": "/wms/JohnstonCo?",
    "params": {
      "layers": "citylimits",
      "transparent": true
    }
  },{
    "type": "WMS",
    "text": "Building Footprints - 2010",
    "name": "JC_Building_Footprints_2010",
    "visible": true,
    "url": "/wms/JohnstonCo?",
    "params": {
      "layers": "building_footprints",
      "transparent": true
    }
  },{
    "type": "WMS",
    "text": "Parcels",
    "name": "parcels",
    "visible": true,
    "url": "/wms/JohnstonCo?",
    "params": {
      "layers": "parcels",
      "transparent": true
    }
  },{
    "type": "WMS",
    "text": "NCDOT Roads",
    "name": "NCDOT-LRS_ARCS",
    "visible": true,
    "url": "/wms/JohnstonCo?",
    "params": {
      "layers": "NCDOT-LRS_ARCS",
      "transparent": true
    },
    "options":{
      "singleTile": true
    }
  },{
    "type": "WMS",
    "text": "NCDOT Roads annotation",
    "name": "NCDOT-LRS_ARCS-annotation",
    "visible": true,
    "url": "/wms/JohnstonCo?",
    "params": {
      "layers": "NCDOT-LRS_ARCS-annotation",
      "transparent": true
    },
    "options": {
      "singleTile": true
    }
  },{
    "type": "WMS",
    "text": "JC Street centerlines",
    "name": "JC-Streets",
    "url": "/wms/JohnstonCo?",
    "params": {
        "layers": "streets",
        "transparent": true
    },
    "options": {
    }
  },{
    "type": "WMS",
    "text": "JC Street annotation",
    "name": "JC-Streets_Text",
    "url": "/wms/JohnstonCo?",
    "params": {
        "layers": "streets_text",
        "transparent": true
    },
    "options": {
    }
  },{
    "type": "WMS",
    "text": "JC Waterlines",
    "name": "JC-Waterlines",
    "url": "/wms/JohnstonCo?",
    "params": {
        "layers": "waterline",
        "transparent": true
    }
  },{
    "type": "WMS",
    "text": "JC Sewerlines",
    "name": "JC-Sewerlines",
    "url": "/wms/JohnstonCo?",
    "params": {
        "layers": "sewerline",
        "transparent": true
    },
    "options": {
        "gutter": 0
    }
  },{
    "type": "WMS",
    "text": "JC County Hydrants",
    "name": "JC-County_Hydrants",
    "url": "/wms/JohnstonCo?",
    "params": {
        "layers": "hydrants",
        "transparent": true
    },
    "options": {
        "gutter": 0
    }
  },{
    "type": "WMS",
    "text": "JC Municipal Hydrants",
    "name": "JC-Municipal_Hydrants",
    "url": "/wms/JohnstonCo?",
    "params": {
        "layers": "municipalhydrants",
        "transparent": true
    },
    "options": {
        "gutter": 0
    }
  }
];

export default layersConfig;
